import BaseApiError from './base'

class UnauthorisedError extends BaseApiError {
  readonly type = 'UNAUTHORIZED'
  readonly reason?: string
  readonly description?: string

  constructor(reason?: string, description?: string) {
    super()

    this.reason = reason
    this.description = description
  }
}

export default UnauthorisedError
